export enum ClubFields {
  Id = 'id',
  Name = 'groupName',
  Type = 'type',
  Description = 'groupDescription',
  Owner = 'owner',
  Admins = 'admins',
  Staff = 'staff',
  Members = 'members',
  Location = 'location',
  Status = 'status',
  DuprId = 'duprId',
  Users = 'users',
  InvitedUsers = 'invitedUsers',
  ShareLink = 'shareLink',
  CreatedAt = 'created_at',
}

export const ClubLabels = {
  [ClubFields.Id]: 'Id',
  [ClubFields.Name]: 'Name',
  [ClubFields.Description]: 'Description',
  [ClubFields.Owner]: 'Owner',
  [ClubFields.Admins]: 'Admins',
  [ClubFields.Staff]: 'Staff',
  [ClubFields.Members]: 'Members',
  [ClubFields.Location]: 'Location',
  [ClubFields.Status]: 'Status',
  [ClubFields.DuprId]: 'DUPR Club ID',
  [ClubFields.CreatedAt]: 'Created At',
};
